<template>
    <v-expansion-panel :disabled="disabled">
        <v-expansion-panel-header ripple class="text-body-2" @click="routeTo">
            <v-row no-gutters>
                <v-col>
                    <router-link v-if="isLinkEnabled" ref="panel-link" :to="to" class="blue--text" @click.prevent>
                        {{ headerText }}
                    </router-link>
                    <template v-else>
                        {{ headerText }}
                    </template>
                </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <slot name="content" />
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script lang="ts">
import { Prop, Component, Vue } from 'vue-property-decorator';
import type { RawLocation } from 'vue-router';

@Component
export default class LinkedHeaderExpansionPanel extends Vue {
    @Prop({ default: undefined }) readonly to: RawLocation | undefined;
    @Prop({ default: '' }) readonly headerText: string;
    @Prop({ default: false }) readonly disabled: boolean;

    get isLinkEnabled(): boolean {
        return !!this.to && !this.disabled;
    }

    routeTo(e) {
        if (!this.isLinkEnabled) {
            return;
        }

        // IE11対策
        //  * IE11だとbutton要素の子孫の要素のイベントが取れない
        //  * v-expansion-panel-header コンポーネントの実装はbutton要素
        // であるため、この構成ではrouter-linkのリンクが動作しない
        // v-expansion-panel-header 要素でクリックイベントが発生した座標から判定する
        const linkAreaRect = (this.$refs['panel-link'] as any).$el.getBoundingClientRect();

        const left = linkAreaRect.left;
        const top = linkAreaRect.top;
        const width = linkAreaRect.width;
        const height = linkAreaRect.height;

        if (left <= e.clientX && e.clientX < left + width && top <= e.clientY && e.clientY < top + height) {
            this.$router.push(this.to);
            e.preventDefault();
        }
    }
}
</script>
